import transform from 'lodash/transform';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
import { Dictionary } from 'lodash';

function differenceBetweenObjects(
    object: Dictionary<{}>,
    base: Dictionary<{}>
) {
    function changes(object: Dictionary<{}>, base: Dictionary<{}>) {
        return transform(object, function(result, value, key) {
            const _result = result as any;
            const _value = value as Dictionary<{}>;

            if (!isEqual(value, base[key])) {
                _result[key] =
                    isObject(value) && isObject(base[key])
                        ? changes(_value, base[key])
                        : value;
            }
        });
    }
    return changes(object, base) as Object;
}

export { differenceBetweenObjects };
